import { render, staticRenderFns } from "./InpaintDetail.vue?vue&type=template&id=649ab7d6&scoped=true"
import script from "./InpaintDetail.vue?vue&type=script&lang=js"
export * from "./InpaintDetail.vue?vue&type=script&lang=js"
import style0 from "./InpaintDetail.vue?vue&type=style&index=0&id=649ab7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649ab7d6",
  null
  
)

export default component.exports